import React, { useId, useState } from 'react';

import {
    IconArrowDown,
    IconArrowUp
} from '$partials/icon/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').Gear}.
 */
const Gear = ({
    anchorId,
    heading,
    rows
}) => {
    const headingId = useId();
    const panelIdPrefix = useId();
    const rowsPanelId = useId();

    const [openRows, setOpenRows] = useState([]);
    const [isRowsOpen, setIsRowsOpen] = useState(false);

    const toggleRow = (id) => {
        setOpenRows((open) => {
            if (open.includes(id)) {
                return open.filter((openId) => openId !== id);
            }

            return [...open, id];
        });
    };

    return (
        <section
            aria-labelledby={headingId}
            className='scroll-mt-110 sm:scroll-mt-[140px] md:scroll-mt-[145px]'
            id={anchorId}>
            {heading && (
                <h2
                    className='layout-grid-col'
                    id={headingId}>
                    <button
                        aria-controls={rowsPanelId}
                        aria-expanded={isRowsOpen}
                        className='w-full flex items-start justify-between gap-x-8 text-left cursor-pointer type-style-heading md:hidden'
                        onClick={() => setIsRowsOpen(!isRowsOpen)}
                        type='button'>
                        {heading}

                        <span className='shrink-0'>
                            <IconArrowDown
                                className={`transition-transform duration-300 ${isRowsOpen ? 'rotate-180' : ''}`}
                                height={20}
                                width={20} />
                        </span>
                    </button>
                    {!isRowsOpen && <div className='md:hidden h-1 bg-neutral-400 mt-16' />}


                    <span className='hidden md:block type-style-heading'>
                        {heading}
                    </span>
                </h2>
            )}

            {rows?.length > 0 && (
                <div
                    className='mt-16 sm:mt-24 md:block'
                    hidden={!isRowsOpen}
                    id={rowsPanelId}>
                    {rows.map((row) => {
                        const isOpen = openRows.includes(row.id);
                        const panelId = `${panelIdPrefix}-${row.id}`;

                        return (
                            <div
                                className='relative sm:flex sm:flex-row sm:flex-wrap'
                                key={row.id}>
                                <div className='w-full layout-grid-col'>
                                    <div className='h-1 bg-neutral-400' />
                                </div>

                                <h3 className='w-full sm:w-2/8'>
                                    <div className='layout-grid-col'>
                                        <button
                                            aria-controls={panelId}
                                            aria-expanded={isOpen}
                                            className='w-full flex items-start justify-between gap-x-8 py-14 sm:py-16 text-left cursor-pointer type-style-body-bold'
                                            onClick={() => toggleRow(row.id)}
                                            type='button'>
                                            {row.subHeading}

                                            <span className='shrink-0 sm:absolute sm:right-4 sm:top-18'>
                                                <IconArrowDown
                                                    className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                                                    height={20}
                                                    width={20} />
                                            </span>
                                        </button>
                                    </div>
                                </h3>

                                <div
                                    className='w-full sm:w-5/8'
                                    hidden={!isOpen}
                                    id={panelId}>
                                    <div className='layout-grid-col'>
                                        {row.text && (
                                            <div
                                                className='pb-14 sm:py-16 rich-text type-style-body [&>*]:mb-0'
                                                dangerouslySetInnerHTML={{ __html: row.text }} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Gear;
